import { render, staticRenderFns } from "./BulkAlertMessageModal.vue?vue&type=template&id=4d1fc452"
import script from "./BulkAlertMessageModal.vue?vue&type=script&lang=js"
export * from "./BulkAlertMessageModal.vue?vue&type=script&lang=js"
import style0 from "./BulkAlertMessageModal.vue?vue&type=style&index=0&id=4d1fc452&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports